import React, { useEffect, useState } from 'react'
import ApiService from '../../functions/apiService';
import { useSelector } from 'react-redux';
import MyTable from './MyTable';
import { getGridStringOperators } from '@mui/x-data-grid';

export default function ManagementDetail() {
  const [row, setRow] = useState([]);
  let data = useSelector((state) => state.dashboardReducer.Data)

  useEffect(() => {
    ApiService.get('/todayDetails', { date: data.date }, 'todayDetails').then(({ data }) => {
      setRow(data.data)
    })
  }, [data])

  let columns = [
    {
      field: "ShiftName",
      headerName: "Shift",
      flex: 1,
      minWidth: 200,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "DetailType",
      headerName: "Detail Type",
      flex: 1,
      minWidth: 200,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "AssignmentText",
      headerName: "Assignment",
      flex: 1,
      minWidth: 200,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "DetailText",
      headerName: "Description",
      flex: 1,
      minWidth: 250,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "PositionName",
      headerName: "Rank",
      flex: 1,
      minWidth: 200,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "EMT",
      headerName: "EMT",
      flex: 1,
      minWidth: 200,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "StatusText",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ]

  return (
    <div>
      {row && row.length > 0 &&
        <>
          <div className='m-3 pb-2'>
            <p className='my-2'>Details</p>
            <MyTable
              rows={row}
              columns={columns}
              useTopFilter={false}
              hideFooter={true}
              checkboxSelection={false}
            />
          </div>
        </>
      }
    </div>
  )
}
